import { jsx as _jsx } from "react/jsx-runtime";
import messages from './messages';
import { FormattedMessage } from 'react-intl';
export const Logout = () => {
    return (_jsx("div", { children: _jsx(FormattedMessage, Object.assign({}, messages.logout)) }));
};
Logout.displayName = 'Logout';
